import { ChevronRightIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  Flex,
  Heading,
  Image,
  Text,
} from '@chakra-ui/react';
import { SliceComponentProps } from '@prismicio/react';
import React from 'react';
import Link from '../../Link/Link';

const FooterCTASlice = (props: FooterCTASliceType) => {
  const { slice } = props;
  return (
    <Flex justify='center' mt={{base: '60px', lg:'100px'}}>
      <Flex pos='relative' py='60px' mx={{base: '24px', lg:'40px'}} gridGap='20px' flexDir={{base: 'column', lg:'row'}} justify='space-between' align='center' maxW='1033px' w='100%'>
        <Box pos='absolute' w='100vw' top='0' bottom='0' ml='-50vw' left='50%' zIndex='-2' bg='aliceblue.100' overflowY='hidden'>
        <Image pos='absolute' maxH='96px' mr='-50vw' right='50%' top={{base: '-40px', md:'19px'}} alt={slice.primary.left_bg_icon.alt} src={slice.primary.left_bg_icon.url} zIndex='-1' />
        <Image pos='absolute' maxH='96px' ml='-50vw' left='50%' top={{base: 'unset', md:'83px'}} bottom={{base: '-50px', md:'unset'}} alt={slice.primary.right_bg_icon.alt} src={slice.primary.right_bg_icon.url} zIndex='-1' />
        </Box>
        <Flex gridGap='8px' flexDir='column' maxW='768px' w='100%'>
          <Heading fontSize='32px' fontWeight='700' color='blue.700'>{slice.primary.footer_cta_title}</Heading>
          <Text>{slice.primary.footer_cta_body}</Text>
        </Flex>
        <Flex gridGap='24px' justify={{base:'flex-start', lg: 'flex-end'}} w={{base:'100%', lg: 'unset'}}>
          {slice.items.map((item, index) => ( 
            <Link to={item.footer_button_url} key={index}>
              <Button variant={item.footer_button_variant} py='12px' px='20px'>
                <Flex gridGap='8px' align='center'>
                  {item.footer_button_label}
                  <ChevronRightIcon/>
                </Flex>
              </Button>
            </Link>
          ))}
        </Flex>
      </Flex>
    </Flex>
  );
};

export type FooterCTASliceType = SliceComponentProps<{
  id: string;
  items: {
    footer_button_variant?: string;
    footer_button_url?: string;
    footer_button_label?: string;
  }[];
  primary: {
    footer_cta_body?: string;
    footer_cta_title?: string;
    left_bg_icon?: {
      url: string;
      alt: string;
    };
    right_bg_icon?: {
      url: string;
      alt: string;
    };
  };
  slice_type: string;
}>;

export default FooterCTASlice;